import { Box, Grid } from "@deere/fuel-react";
import { Spinner } from "@deere/ux.uxframe-react";
import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { Redirect } from "react-router-dom";
import { signInSurveyLogin } from "../../services/survey.service";
import "./surveyLogin.css";
import { CRS_SURVEY_TEMPLATES, ST, SURVEY_EXT_ROUTES } from "../../utils/surveyLiterals";

export default function SurveyLogin(props) {
  useEffect(() => {
    props.setShowHeaderFooter(false);
  }, []);
  const history = useHistory();
  const queryString = window.location.search;
  const queryParams = new URLSearchParams(queryString);
  const decryptedParam = queryParams.get("rn");
  const [showErrorPage, setShowErrorPage] = React.useState(false)


  const handleSignIn = () => {
    signInSurveyLogin(decryptedParam)
      .then((response) => {
        if (response !== null) {
          let pathname = "";
          if (response.template && response.template !== "") {
            pathname = response.template === CRS_SURVEY_TEMPLATES.PART ? "surveypartext" : "surveyext";
          } else {
            pathname = SURVEY_EXT_ROUTES.has(response.code) ? SURVEY_EXT_ROUTES.get(response.code) : SURVEY_EXT_ROUTES.get('DEFAULT');
          }
          let state = {
            previous: "/surveyLogin",
            surveyType: response.description,
            supplierName: `${response.supplierNumber} - ${response.supplierName ? response.supplierName : "Supplier"}`,
            queryParam: response.id,
            surveyCode: response.code,
            isAuthNonOkta: true,
            endDate: response.endDate,
            updatedByName: response.assignmentUpdateDetails.updatedBy,
            updatedTs: response.assignmentUpdateDetails.lastUpdatedTs,
          };
          if (response.code === ST) {
            state = {
              ...state,
              campaign: { updatedBy: response.assignmentUpdateDetails.updatedBy, updatedts: response.assignmentUpdateDetails.lastUpdatedTs },
            };
          }
          history.replace({
            pathname: pathname,
            state: state,
          });
        } else {
          setShowErrorPage(true)
        }
      })
      .catch(() => {
        setShowErrorPage(true)
      });
  };

  useEffect(() => { handleSignIn() }, []);

  if (showErrorPage) {
    return <Redirect to={{ pathname: "/sterror" }} />;
  }

  const spinner = () => (
    <div className='ml-2' style={{ display: 'flex', justifyContent: 'center' }}>
      <Spinner
        as="span"
        animation="grow"
        size="sm"
        role="status"
        aria-hidden="true"
      />
      <Spinner
        as="span"
        animation="grow"
        size="sm"
        role="status"
        aria-hidden="true"
      />
      <Spinner
        as="span"
        animation="grow"
        size="sm"
        role="status"
        aria-hidden="true"
      />
    </div>
  )

  return (
    <Grid container justifyContent={"center"} sx={{ height: "90vh", paddingTop: "10vh" }}>
      <Grid item xs={12} sm={6} lg={4}>
        <Box p={4} className="company-logo">
          <h1>
            <img src="https://sso-dev.johndeere.com/fs/bco/1/fs0j00kt1l6HOTmvR0h7" alt="logo" height="40px" />
          </h1>
        </Box>
        {spinner()}
      </Grid>
    </Grid>
  );
}
